import {frontPageContentManager} from '../../../api/frontPageContentManager';
import WelcomePageHighlightBlock from '../../../api/welcomePageHighlightBlockEntity';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchWelcomePageHighlightMainItemsAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  frontPageContentManager.fetchWelcomePageHighlightMainItemsAsync()
    .then((highlightMainItems) => {
      dispatch(fetchWelcomePageHighlightMainItemsAsyncCompleted(highlightMainItems));
    });
};

const fetchWelcomePageHighlightMainItemsAsyncCompleted = (highlightMainItems: WelcomePageHighlightBlock[]) => ({
  meta: {
    httpEnd: true,
  },
  payload: highlightMainItems,
  type: actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_MAIN_ITEMS_COMPLETED
});

export const fetchWelcomePageHighlightSubMainItemsAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());
  
    frontPageContentManager.fetchWelcomePageHighlightSubMainItemsAsync()
      .then((highlightMainItems) => {
        dispatch(fetchWelcomePageHighlightSubMainItemsAsyncCompleted(highlightMainItems));
      });
  };
  
  const fetchWelcomePageHighlightSubMainItemsAsyncCompleted = (highlightMainItems: WelcomePageHighlightBlock[]) => ({
    meta: {
      httpEnd: true,
    },
    payload: highlightMainItems,
    type: actionTypes.FETCH_WELCOME_PAGE_HIGHLIGHT_SUB_MAIN_ITEMS_COMPLETED
  });


// WEBPACK FOOTER //
// ./src/components/welcomePageHighlight/actions/fetchWelcomePageHighlightMainItems.ts